import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3e77a1c8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`General guidance`}</h2>
    <p>{`Tabs are used to quickly navigate between views within the same context.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.58695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABeElEQVQ4y61RW27CMBD0EXoJ4JMr+ETwwSd34CG4H0IECIgkJLHjJCQ79S5Ni6p+FFpLo/Hu2uMdr1L/vSaTydt0OtXj8ViPRiPhv0ANBgM9HA7hGf1+X9Dr9V6GWq/XerFYYDabYT6fE/NyuYTPY7VaPQ0FQDdNA2MMFUXRZllGbduSz78ElSSJLqxlQVhryVoDLyqxf+BX8PdwvV4Fyl/WxhbITYE0M2SMhXOFh0NZlqiqSvinfRfzWW6Aoby6PkcZtsEZqblReL5gu93icDggCAJsNhthjjnf7Xe7ncT7/R6n0wl5ngtUXVUaRGiaG/gPytLBf4MU2UIURcJpmiKOYyQf1vhMHCey57N1XQsUEclQnOPWS2IbHLMVPxw8u2TK/MLxeEQYhuQhFjjmv5G2vQMWt66GKQnG3VHfiItS7yCCPCW24AWIRXhyzI8dErWI0gqXHIhzgi3vAt2Dnx16e/ohSd8tfF1qkRc3ZL7pzN0Fu/qj4DumTyX1zlFc8AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "An example of tabs being used.",
            "title": "An example of tabs being used.",
            "src": "/static/46a56b2df5af0e64dea1a659cf8ec895/c801a/tab-usage-1.png",
            "srcSet": ["/static/46a56b2df5af0e64dea1a659cf8ec895/1a057/tab-usage-1.png 288w", "/static/46a56b2df5af0e64dea1a659cf8ec895/8418d/tab-usage-1.png 576w", "/static/46a56b2df5af0e64dea1a659cf8ec895/c801a/tab-usage-1.png 1152w", "/static/46a56b2df5af0e64dea1a659cf8ec895/7d33b/tab-usage-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2>{`Format`}</h2>
    <h4>{`Tab label`}</h4>
    <p>{`Each tab label describes the content contained within it. Labels are concise and use no more than two words. Keep in mind that at mobile widths and during translation, the character length of a label will impact the experience. Do not use icons in tab labels.`}</p>
    <h4>{`Number of tabs`}</h4>
    <p>{`In most scenarios, you should use no more than six tabs. This maintains an uncluttered UI and reduces cognitive load for users. If more than six tabs are needed, consider other navigation patterns, such as a `}<a parentName="p" {...{
        "href": "/components/UI-shell-left-panel/code"
      }}>{`side-nav`}</a>{`.`}</p>
    <h4>{`Order`}</h4>
    <p>{`Tab order should be consistent across an experience. Tabs with related content should be grouped adjacent to each other.`}</p>
    <h2>{`Variations`}</h2>
    <p>{`There are two variations of tabs, default and container. They are hierarchically the same and should never be nested within each other.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Tab styles`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Default`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A standalone tab that can also be nested within components. It is commonly used with smaller content areas.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Container`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An emphasized tab that is always paired with an attached background container. It is commonly used for larger content areas, like sub-pages. `}</td>
        </tr>
      </tbody>
    </table>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "33.96739130434783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAA50lEQVQoz32OWW6DMBRFvUV+CfCTroelsQZAYghjiSdihls/VzRNRfqkI7/x+rK6rlGW5SlVVaEoCmit0bYt0jRFnufIsuyHvzX7uF4RXC6IohBh+CQIAtuL4HkekiRBHMcup77v+29hd64wWTgXFu4QQmCeZwe5W9cV4ziiaW7o+87So+u+32EYXmDDfUYzKvS2OJamaXIiy7I4tm0DlxqfXOPxMLZn3Ge0Q7HvO45gSgpoJaEcClJKB7k8MMZgs0fPs9cgYfrUCToBK6TeQHNySUdnkNAxp5xRQZb/gxbp4Gz22yHVX1xR+1757DaGAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "An example of container tabs on the left and default tabs on the right.",
            "title": "An example of container tabs on the left and default tabs on the right.",
            "src": "/static/6f3f2636fe208b5fda1f3085b00d4bfd/c801a/tab-usage-2.png",
            "srcSet": ["/static/6f3f2636fe208b5fda1f3085b00d4bfd/1a057/tab-usage-2.png 288w", "/static/6f3f2636fe208b5fda1f3085b00d4bfd/8418d/tab-usage-2.png 576w", "/static/6f3f2636fe208b5fda1f3085b00d4bfd/c801a/tab-usage-2.png 1152w", "/static/6f3f2636fe208b5fda1f3085b00d4bfd/7d33b/tab-usage-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Caption mdxType="Caption">Left: container tab. Right: default tab .</Caption>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      